import React, { useEffect } from "react";
import { Field } from "formik";
import Select from "components/Form/Select";
import { Checkbox } from "components/Form/SpecialButtons";

const RolesForm = ({ errors, isAdmin, values, partners, centers, setFieldValue, nurses }) => {
	useEffect(() => {
		if (values.access_nurse_app === "CT3" && !values.external_sampler) {
			setFieldValue("external_sampler", true);
		}
	});
	return (
		<div>
			<Field
				component={Select}
				name="role"
				customlabel="Fonction"
				placeholder="Sélectionner une fonction"
				options={[
					{ value: "NURSE", label: "Infirmier/ère" },
					// { value : "SAMPLER", label: "Préleveur/euse"},
					// { value : "BIOLOGIST", label: "Biologiste"},
					// { value : "TECHNICIAN", label: "Technicien"},
					{ value: "SECRETARY", label: "Secrétaire" },
					{ value: "COMPUTER", label: "D.S.I" },
				]}
				errors={errors}
				required
			/>
			<Field
				component={Select}
				name="secretary_level"
				customlabel="Niveau d'expertise"
				placeholder="Sélectionner un niveau"
				options={[
					{ value: "JUNIOR", label: "Junior" },
					{ value: "SENIOR", label: "Senior" },
				]}
			/>

			<Field
				component={Select}
				name="rights"
				customlabel="Autorisation"
				placeholder="Sélectionner une autorisation"
				options={[
					{ value: "INACTIVE", label: "Inactif" },
					{ value: "SIMPLE", label: "Utilisateur simple" },
					{ value: "MANAGER", label: "Manager" },
					isAdmin && { value: "ADMIN", label: "Administrateur" },
				]}
				errors={errors}
				required
			/>
			<Field
				component={Select}
				name="access_nurse_app"
				customlabel="Accès à Nurse App"
				options={[
					{ value: "CT1", label: "CT1" },
					{ value: "CT2", label: "CT2" },
					{ value: "CT3", label: "CT3" },
					{ value: "CT4", label: "CT4" },
					{ value: "CT5", label: "CT5" },
					{ value: "CT6", label: "CT6" },
					{ value: "CT7", label: "CT7" },
					{ value: null, label: "Aucun accès" },
				]}
				errors={errors}
				required
			/>
			<Field
				checked={values.external_network}
				id="external_network"
				name="external_network"
				customlabel="Réseau MyRdv externe"
				component={Checkbox}
			/>
			{values.external_network && (
				<Field
					component={Select}
					name="networkMyRdvId"
					customlabel="Réseau MyRdv"
					placeholder="Sélectionner un réseau"
					options={[
						...nurses?.networks?.map((network) => {
							return {
								value: network.id,
								label: `${network.name}`,
								data: network,
							};
						}),
						{
							value: null,
							label: "\u00a0",
							data: null,
						},
					]}
					required={values.external_network}
				/>
			)}
			{!values.external_network && (
				<Field
					component={Select}
					name="nurseMyRdvId"
					menuPlacement="top"
					customlabel="Infirmière MyRdv"
					placeholder="Sélectionner une infirmière"
					options={[
						...nurses.list.map((nurse) => {
							return {
								value: nurse.id,
								label: `${nurse.lastname} ${nurse.name}`,
								data: nurse,
							};
						}),
						{
							value: null,
							label: "\u00a0",
							data: null,
						},
					]}
				/>
			)}

			<Field checked={values.external_sampler} id="external_sampler" name="external_sampler" customlabel="Préleveur externe" component={Checkbox} />

			{values.external_sampler && (
				<Field
					component={Select}
					name="external_center"
					customlabel="Centre externe"
					placeholder="Sélectionner un centre"
					options={[
						...centers.map((center) => {
							return {
								value: center.id,
								label: `${center.name} `,
								data: center,
							};
						}),
						{
							value: null,
							label: "\u00a0",
							data: null,
						},
					]}
					errors={errors}
					required={values.external_sampler}
				/>
			)}
			<Field
				component={Select}
				name="nurse_app_center"
				customlabel="Centre Nurse App"
				placeholder="Sélectionner un centre"
				options={[
					...centers.map((center) => {
						return {
							value: center.id,
							label: `${center.name} `,
							data: center,
						};
					}),
					{
						value: null,
						label: "\u00a0",
						data: null,
					},
				]}
				errors={errors}
				required={!values.external_sampler && ["CT7"].includes(values.access_nurse_app)}
			/>
			{values.external_sampler && partners && partners.length > 0 && (
				<Field
					component={Select}
					name="partnerCompany"
					customlabel="Société partenaire"
					placeholder="Sélectionner une société partenaire"
					options={partners.map((partner) => ({ value: partner.id, label: partner.name }))}
					errors={errors}
				/>
			)}
		</div>
	);
};

export default RolesForm;
